export default {
  registration: 'registration',
  tikTokClickIdInitiateCheckout: 'ttclidInitiateCheckout',
  alreadyShownRoutineNewFormulaModal: 'alreadyShownRoutineNewFormulaModal',
  latestFormulationIdShipped: 'latestFormulationIdShipped',
  bannerDismissed: 'bannerDismissed',
  checkoutVenmoActivation: 'checkoutVenmoActivation',
};
